export default function PollManagement({ children: poll, onStop, onRemove, onShare }) {
    const votes = poll.results && poll.results.reduce((x, y) => x + y, 0);

    return (
        <div className="flex flex-col space-y-3 items-stretch">
            <p className="text-center text-gray-700">
                {poll.active ? "A poll is currently running. You can stop it anytime to prevent new votes. The results will still be visible." : "The poll is finished. No new votings are allowed and everybody can see the results."}
                {votes != null && <> {poll.active ? "Currently " : ""}<b>{votes} vote{votes === 1 ? "" : "s"}</b> {poll.active ? "are" : "were"} collected.</>}
            </p>

            {onStop && <button className="btn-primary" onClick={onStop}>Stop current poll</button>}
            {onRemove && <button className="btn-primary" onClick={onRemove}>Hide results</button>}
            {onShare && <button className="btn-secondary" onClick={onShare}>Share results as message</button>}
        </div>
    );
}
